/**
 * Created by dok on 01/02/2017.
 */
angular.module('tf.controllers')

    .controller('AddPaymentMethodController', function ($scope, $rootScope, Session, HttpService) {
        $scope.isValid = false;
        $scope.isWorking = false;

        // Create an instance of Elements.
        var elements = $rootScope.stripe.elements();

        // Custom styling can be passed to options when creating an Element.
        // (Note that this demo uses a wider set of styles than the guide below.)
        var style = {
            base: {
                color: '#32325d',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        // Create an instance of the card Element.
        var card = elements.create('card', {style: style});

        $scope.onInit = function(){
            // Add an instance of the card Element into the `card-element` <div>.
            card.mount('#card-element');
            // Handle real-time validation errors from the card Element.
            card.addEventListener('change', function(event) {
                var displayError = document.getElementById('card-errors');
                if (event.error) {
                    displayError.textContent = event.error.message;
                    $scope.isValid = false;
                } else {
                    if(event.complete) {
                        $scope.isValid = true;
                        $scope.$apply();
                    }
                    displayError.textContent = '';
                }
            });
        };

        $scope.addPaymentMethod = function(){
            $scope.isWorking = true;
            $rootScope.stripe.createSource(card,{owner:{email:Session.user.local.email}}).then(function(result) {
                if (result.error) {
                    // Inform the user if there was an error.
                    var errorElement = document.getElementById('card-errors');
                    errorElement.textContent = result.error.message;
                    $scope.isWorking = false;
                } else {
                    // Send the token to your server.
                    // console.log(result);
                    HttpService.post('billing/update',{source:result.source}).then(function(res){
                        $scope.$close(true);
                    },function(err){
                        $scope.isWorking = false;
                    });
                }
            });
        };



        $scope.cancel = function(){
            $scope.$close();
        };

    });